import {
  GET_MATCHES,
  GET_MATCHES_SUCCESS,
  GET_MAIN_DRAW,
  GET_MAIN_DRAW_SUCCESS,
  API_ERROR,
  GET_LOGS,
  GET_LOGS_SUCCESS,
} from "./actionTypes"

export const getLogs = (comptId, activeFilters, activePage) => {
  return {
    type: GET_LOGS,
    payload: { comptId, filters: activeFilters, activePage },
  }
}

export const getLogsSuccess = logs => {
  return {
    type: GET_LOGS_SUCCESS,
    payload: { logs },
  }
}

let nextReadId = 0

export const getMatches = ({ competitionId }) => {
  return {
    type: GET_MATCHES,
    payload: { competitionId, requestId: ++nextReadId },
  }
}

export const getMatchesSuccess = (matches, meta) => {
  return {
    type: GET_MATCHES_SUCCESS,
    payload: matches,
    meta,
  }
}

export const getMainDraw = competitionId => {
  return {
    type: GET_MAIN_DRAW,
    payload: { competitionId, requestId: ++nextReadId },
  }
}

export const getMainDrawSuccess = (matchesGroups, meta) => {
  return {
    type: GET_MAIN_DRAW_SUCCESS,
    payload: matchesGroups,
    meta,
  }
}

export const apiError = (error, meta) => {
  return {
    type: API_ERROR,
    payload: error,
    meta,
  }
}
